module.exports = __webpack_public_path__ + "img/Etape 1.efee53c8.png";